import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { AffiliatesApiAdapter } from '../adapters/AffiliatesApiAdapter';
import { AffiliatesTotals } from '../models/AffiliatesTotals';

export const useAffiliatesTotals = (params?: {
  date_from?: string;
  date_to?: string;
}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new AffiliatesApiAdapter(httpClient);

  const query = useQuery<AffiliatesTotals, Error>({
    queryKey: ['affiliatesTotals', params],
    queryFn: () => apiAdapter.getAffiliatesTotals(params),
    staleTime: 5 * 60 * 1000,
  });

  return query;
};

export const useAffiliateCode = () => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new AffiliatesApiAdapter(httpClient);

  const query = useQuery({
    queryKey: ['affiliateCode'],
    queryFn: () => apiAdapter.getAffiliateCode(),
    staleTime: 5 * 60 * 1000,
  });

  return query;
};
